<!--
 * @Author: your name
 * @Date: 2022-03-11 18:10:09
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-13 04:41:28
 * @Description: file content
-->
<template>
  <div>
    <svg class="circle" :width="svgWidth" :height="svgHeight">
      <g>
        <image
          xlink:href="@/assets/lottery/tablebg.png"
          x="0"
          y="-17"
          :width="svgWidth"
          :height="svgHeight"
        ></image>
        <circle
          class="top-circle"
          v-bind="{ ...circleOptions, r: r1, fill: topCircleFill }"
        ></circle>
        <text class="svg-text" :fill="textFill" :x="textX" :y="textY">
          {{ displayText }}
          <tspan v-bind="{ x: textX, y: parseInt(textY) + 10 + '%' }">
            {{ prized_text }}
          </tspan>
        </text>
        <circle
          class="bottom-circle"
          v-bind="{ ...circleOptions, r: r2, fill: bottomCircleFill }"
          @click="handleClick"
        ></circle>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      displayText: {
        type: String,
        default: () => "",
      },
      topCircleFill: {
        type: String,
        default: () => "#fab33b",
      },
      bottomCircleFill: {
        type: String,
        default: () => "rgba(250, 179, 59, 0.2)",
      },
      prized_text: {
        type: String,
        default: () => "",
      },
      // 下面三个props  后面删除掉 将 判断放到 父组件进行 子组件仅负责 渲染 内容
      // 是否已中奖
      prized_flag: {
        type: Boolean,
        default: () => false,
      },
      // 是否已经参加抽奖
      entered_flag: {
        type: Boolean,
        default: () => false,
      },
      // 是否已开奖
      draw_flag: {
        type: Boolean,
        default: () => false,
      },
    },
    data() {
      return {
        circleOptions: {
          cx: "50%" /* circle cx */,
          cy: "46%" /* circle cy */,
        },
        svgWidth: "375px",
        svgHeight: "442px",
        textX: "50%" /* text x */,
        textY: "46%" /* text y */,
        r1: "25%" /* top-circle 半径 */,
        r2: "30%" /* bottom-circle 半径 */,
        textFill: "#fff",
      };
    },
    mounted() {
      this.svgWidth = this.$el.clientWidth + "px";
      this.svgWidth = this.$el.clientWidth + "px";
    },
    svgHeight: function(val, oldVal) {
      console.log("new: %s, old: %s", val, oldVal);
      this.svgHeight = this.$el.clientHeight + "px";
    },
    watch: {
      svgWidth: function(val, oldVal) {
        console.log("new: %s, old: %s", val, oldVal);
        this.svgWidth = this.$el.clientWidth + "px";
      },
      svgHeight: function(val, oldVal) {
        console.log("new: %s, old: %s", val, oldVal);
        this.svgHeight = this.$el.clientHeight + "px";
      },
    },
    methods: {
      handleClick(event) {
        this.$emit("circleClick", event);
      },
    },
  };
</script>
<style lang="less" scoped>
  // MARK:
  svg.circle {
    g {
      .svg-text {
        font-size: 6.5vw;
        text-anchor: middle;
      }
    }
  }
</style>
